import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";
import {map} from "rxjs/operators";
import {Cheque} from "../models/cheque.model";
import {Bank, UserBank} from "../models/bank.model";
import {Posicion} from "../models/posicion.model";

@Injectable({
  providedIn: 'root'
})
export class DashboardApiService {

  constructor(
    private http: HttpClient
  ) { }

  getPosicion(): Observable<Posicion> {
      return this.http.get<Posicion>(environment.apiBaseUrl+"/core/portal/profile/posicion");
  }

}

